<template>
  <v-data-table
    :items="getFilteredItems"
    :headers="getHeaders"
    :mobile-breakpoint="0"
    :items-per-page="$vuetify.breakpoint.xsOnly ? getProducts.length + 1 : 25"
    :hide-default-header="$vuetify.breakpoint.xsOnly"
    hide-default-footer
    :search="search"
    sort-by="origin_value"
    :sort-desc="true"
    dense
    @page-count="pageCount = $event"
    :page.sync="page"
  >
    <template v-slot:item.nom="{ item }">
      <span class="font-weight-bold">{{
        item.data !== undefined && item.data.order_name !== null
          ? item.data.order_name
          : item.nom
      }}</span>
    </template>
    <template v-slot:item.value="{ item }">
      <v-row align="center" justify="end" no-gutters>
        <j-decimal-input
          class="no-before my-1"
          single-line
          dense
          v-model="item.value"
          label=""
          filled
          unit-suffix
          :suffix="getUnit(item)"
          hide-details
          style="max-width: 150px;"
        ></j-decimal-input>
      </v-row>
    </template>
    <template v-slot:item.value_max="{ item }">
      <v-row align="center" justify="end" no-gutters>
        <j-decimal-input
          class="no-before my-1"
          single-line
          dense
          v-model="item.value_max"
          label=""
          filled
          unit-suffix
          :suffix="getUnit(item)"
          hide-details
          style="max-width: 150px;"
        ></j-decimal-input>
      </v-row>
    </template>
    <template v-slot:item.value_by_sale="{ item }">
      <v-row align="center" justify="end" no-gutters>
        <j-decimal-input
          class="no-before my-1"
          single-line
          dense
          v-model="item.value_by_sale"
          label=""
          filled
          unit-suffix
          :suffix="getUnit(item)"
          hide-details
          style="max-width: 150px;"
        ></j-decimal-input>
      </v-row>
    </template>
    <template v-slot:top>
      <v-row no-gutters class="mb-3">
        <InventoryTemplateTagsEditor
          v-model="tags"
        ></InventoryTemplateTagsEditor>
      </v-row>
      <v-row align="center" justify="end">
        <v-col cols="12" sm="6">
          <v-text-field
            dense
            filled
            hide-details
            single-line
            clearable
            prepend-inner-icon="fa-search"
            v-model="search"
            class="no-before"
          ></v-text-field>
        </v-col>
      </v-row>
    </template>
    <template v-slot:footer>
      <v-pagination
        color="accent"
        v-model="page"
        :length="pageCount"
        :total-visible="5"
      ></v-pagination>
    </template>
  </v-data-table>
</template>

<script>
import { api } from "@/api";
import { mapGetters } from "vuex";
import { InventoryTemplateTagsEditor } from "@/modules/Inventory/components";
export default {
  name: "OrderTemplateQuantityGrid",
  components: {
    InventoryTemplateTagsEditor
  },
  props: {
    sales_target: {
      required: true
    },
    quantities: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters(["getProducts", "getStoreId"]),
    getFilteredItems() {
      let items = this.items.filter(
        x =>
          (x.est_intermediaire === false || x.use_inventory_link === true) &&
          x.is_deleted === false
      );
      return this.tags.length > 0
        ? items.filter(
            x => x.data && this.tags.every(t => x.data.tags.includes(t))
          )
        : items;
    },
    getHeaders() {
      if (this.sales_target !== null) {
        return [
          { value: "nom", text: "Produit" },
          { value: "value", text: "Seuil pour commander", align: "end" },
          {
            value: "value_by_sale",
            text: "Quantité en fonction des ventes",
            align: "end"
          },
          { value: "value_max", text: "Maximum en inventaire", align: "end" }
        ];
      } else {
        return [
          { value: "nom", text: "Produit" },
          { value: "value", text: "Seuil pour commander", align: "end" },
          { value: "value_max", text: "Cible d'inventaire", align: "end" }
        ];
      }
    }
  },
  created() {
    this.setItems();
  },
  data() {
    return {
      tags: [],
      search: "",
      page: 1,
      pageCount: 0,
      items: []
    };
  },
  methods: {
    setItems() {
      this.items = [...this.getProducts]
        .filter(
          x =>
            (x.est_intermediaire === false || x.use_inventory_link === true) &&
            x.is_deleted === false
        )
        .map(x => {
          const templateQuantity = this.quantities.find(
            q => q.fk_product === x.id
          );
          if (templateQuantity) {
            return {
              ...x,
              origin_value: Number(templateQuantity.quantity),
              value: Number(templateQuantity.quantity),
              value_max: Number(templateQuantity.quantity_max),
              value_by_sale: Number(templateQuantity.quantity_by_sale),
              templateQuantity: templateQuantity
            };
          } else {
            return {
              ...x,
              origin_value: 0,
              value: 0,
              value_max: null,
              value_by_sale: null,
              templateQuantity: undefined
            };
          }
        });
    },
    async saveQuantities(id) {
      const tasks = [];
      this.items.forEach(x => {
        if (x.templateQuantity) {
          const data = {
            ...x.templateQuantity,
            quantity: x.value,
            quantity_max: x.value_max
          };
          tasks.push(
            api.putRecipeProductOrderQuantity(x.templateQuantity.id, data)
          );
        } else {
          if (x.value > 0) {
            const data = {
              fk_order_template: id,
              fk_product: x.id,
              store: this.getStoreId,
              quantity: x.value,
              quantity_max: x.value_max,
              quantity_by_sale: x.value_by_sale
            };
            tasks.push(api.postRecipeProductOrderQuantity(data));
          }
        }
      });
      await Promise.all(tasks);
    },
    getUnit(item) {
      if (item.data) {
        return item.data.unite_mesure_inventory;
      } else {
        return "";
      }
    }
  }
};
</script>

<style></style>
